import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/views/assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-f7f5d900"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-default page-media detail-content" }
const _hoisted_2 = { class: "info" }
const _hoisted_3 = { class: "names" }
const _hoisted_4 = { class: "name line1" }
const _hoisted_5 = { class: "desc line1 c-thirdary" }
const _hoisted_6 = { class: "line1" }
const _hoisted_7 = { class: "option" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "line",
  style: {"margin":"0 12px"}
}, "|", -1))
const _hoisted_9 = { class: "option" }
const _hoisted_10 = { class: "option" }
const _hoisted_11 = { class: "line2" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-gengduo" }, null, -1))
const _hoisted_13 = { class: "tools" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-bofang" }, null, -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icon i-shoucang" }, null, -1))
const _hoisted_16 = { class: "page-default page-media detail-body" }
const _hoisted_17 = { class: "section" }
const _hoisted_18 = {
  class: "page-title",
  style: {"margin-top":"0"}
}
const _hoisted_19 = {
  key: 0,
  class: "filters"
}
const _hoisted_20 = ["onMouseover"]
const _hoisted_21 = { class: "list" }
const _hoisted_22 = { class: "columns c-thirdary" }
const _hoisted_23 = { class: "item" }
const _hoisted_24 = {
  key: 0,
  class: "no"
}
const _hoisted_25 = {
  key: 1,
  class: "no"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "right" }
const _hoisted_33 = { class: "title" }
const _hoisted_34 = { class: "name c-primary" }
const _hoisted_35 = { class: "author c-thirdary" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1))
const _hoisted_37 = { class: "title" }
const _hoisted_38 = { class: "no c-secondary" }
const _hoisted_39 = { class: "name c-primary" }
const _hoisted_40 = { class: "author c-thirdary" }
const _hoisted_41 = { style: {"flex":"1"} }
const _hoisted_42 = { class: "title" }
const _hoisted_43 = { class: "download" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1))
const _hoisted_45 = { class: "tools" }
const _hoisted_46 = {
  class: "btn red round",
  href: "http://www.fytvapp.net/",
  target: "app"
}

import tongjiApi from '@/api/tongjiApi'
import api from '@/api/fyApi';
import userApi from '@/api/userApi'
import backMusic from '@/store/backMusic';
import device from '@/store/device';
import album, { State } from '@/store/channels/movie';
import favorites from '@/store/mine/favorites';
import user from '@/store/user';
import ImageBackDiv from '@/views/components/ImageBackDiv.vue';
import MoreText from '@/views/components/MoreText.vue';
import Poster from '@/views/components/Poster.vue';
import * as links from '@/views/links';
import { computed, reactive, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import i18, { State as I18State } from '@/store/i18';
import { setting } from '@/config';
import { isMobile } from '@/common/download'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const store = useStore()
const data = computed<State>(() => store.state[album.name])

const i18data = computed<I18State>(() => store.state[i18.name])
const lang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]])

const state = reactive({
    moreVisible: false,
})
const pages = computed(() => {
    let arr = data.value.pages.slice()
    if (pageSortDesc.value) {
        arr.reverse()
    }
    return arr
})
const pageData = computed<MovieResource[]>(() => {
    let list: MovieResource[] = []
    if (data.value.detail) {
        list = data.value.detail.url_list.slice(data.value.pageIndex * data.value.pageSize, pageEnd(data.value.pageIndex))
        if (pageSortDesc.value) {
            list.reverse()
        }
    }
    return list
})

const pageSortDesc = computed(() => data.value.detail ? data.value.detail.listsort == 1 : false)

onMounted(() => {
    if (isMobile() && data.value.detail && setting.first) {
        let url = 'fuyintv://tv/movie?movid=' + data.value.id + '&urlid=' + data.value.detail.url_list[0].urlid
        window.location.href = url
    }
})
function pageEnd(i: number) {
    let end = (i + 1) * data.value.pageSize
    if (data.value.detail) {
        if (end > data.value.detail.url_list.length) {
            end = data.value.detail.url_list.length
        }
    }
    return end
}

function onChangeOrder() {
    if (data.value.detail) {
        data.value.detail.listsort = pageSortDesc.value ? 0 : 1
    }
}

function onPlay(item?: MovieResource) {
    if (!item && data.value.detail && data.value.detail.url_list.length > 0) {
        item = data.value.detail.url_list[0]
    }
    if (item) {
        if (item.mp4) {
            onPlayVideo(item)
        } else if (item.mp3) {
            onPlayAudio(item)
        }
    }
}

function onPlayVideo(item: MovieResource) {
    if (item.mp4 && data.value.detail) {
        router.push(`/channels/movie-player/${data.value.id}/${item.urlid}.html`)
    }
}

function onPlayAudio(item: MovieResource) {
    if (item.mp3 && data.value.detail) {
        backMusic.setPlayList(store, data.value.detail, data.value.detail.url_list)
        backMusic.play(store, item)
        tongjiApi.postVideo('play_audio', item.movid, item.urlid)
    }
}

async function onFavorite() {
    if (user.online(store)) {
        try {
            if (data.value.isFavorite) {
                await favorites.removeId(store, data.value.id)
            } else {
                await favorites.addId(store, data.value.id)
            }
            data.value.isFavorite = !data.value.isFavorite
            // device.toast(store, data.value.isFavorite ? '添加成功' : '删除成功');
        } catch (e) {
            // device.toast(store, data.value.isFavorite ? '删除失败' : '添加失败');
        }
    }
}

function onShare() {

}

async function onDownload(item: MovieResource, type: number) {
    if (user.online(store)) {
        let ttype = ''
        switch (type) {
            case 3:
                if (!item.down_mp4) {
                    return;
                }
                ttype = 'down_movie'
                break;
            case 4:
                if (!item.down_mp3) {
                    return
                }
                ttype = 'down_audio'
                break;
            case 5:
                if (!item.doc) {
                    return
                }
                break;
        }
        try {
            let { url } = await api.getMovieResourceUrl(item.movid, item.urlid, type)
            if (url && /^https?:\/\//i.test(url)) {
                let a = document.createElement('a')
                a.href = url;
                a.target = "_blank"
                a.click();
            }
            if (ttype) {
                tongjiApi.postVideo(ttype, item.movid, item.urlid)
            }
        } catch (e) {
            device.toast(store, lang.value.movieText.album_notfound)
        }
    }
}

function text(value: string) {
    value = value.replace(/<.*?>/g, '')
    value = value.replace(/&[a-z]*?;/ig, '')
    return value
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(data).detail)
      ? (_openBlock(), _createBlock(ImageBackDiv, {
          key: 0,
          class: "detail dark",
          url: _unref(data).detail.thumb
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(Poster, {
                  url: _unref(data).detail.thumb,
                  theme: "album"
                }, null, 8, ["url"]),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, "《" + _toDisplayString(_unref(data).detail.title) + "》", 1),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(data).detail.subtitle), 1)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createTextVNode(_toDisplayString(_unref(data).detail.language) + " ", 1),
                    _hoisted_8,
                    _createTextVNode(" " + _toDisplayString(_unref(data).detail.source), 1)
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createTextVNode(_toDisplayString(_unref(lang).movieText.album_author) + " : ", 1),
                    _createElementVNode("span", null, _toDisplayString(_unref(data).detail.speaker), 1),
                    _createElementVNode("span", null, _toDisplayString(_unref(data).detail.appellation), 1)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createTextVNode(_toDisplayString(_unref(lang).movieText.album_intro) + " : ", 1),
                      _createElementVNode("span", null, _toDisplayString(text(_unref(data).detail.content)), 1)
                    ]),
                    _createElementVNode("a", {
                      class: "more-link link",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(state).moreVisible = true))
                    }, [
                      _createTextVNode(_toDisplayString(_unref(lang).movieText.album_more) + " ", 1),
                      _hoisted_12
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("a", {
                      class: "btn round red",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (onPlay()))
                    }, [
                      _hoisted_14,
                      _createTextVNode(_toDisplayString(_unref(lang).movieText.album_play), 1)
                    ]),
                    _createElementVNode("a", {
                      class: _normalizeClass(["btn round", _unref(data).isFavorite ? 'red' : 'line']),
                      onClick: onFavorite
                    }, [
                      _hoisted_15,
                      _createTextVNode(_toDisplayString(_unref(lang).movieText.album_favorite), 1)
                    ], 2)
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["url"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(lang).movieText.album_playlist), 1),
        (_unref(pages).length > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pages), (i) => {
                return (_openBlock(), _createElementBlock("a", {
                  class: _normalizeClass(["btn", _unref(data).pageIndex == i ? 'red' : 'silver']),
                  onMouseover: ($event: any) => (_unref(data).pageIndex = i)
                }, _toDisplayString(i * _unref(data).pageSize + 1) + "-" + _toDisplayString(pageEnd(i)), 43, _hoisted_20))
              }), 256))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("a", {
              class: "link c-primary",
              onClick: onChangeOrder
            }, _toDisplayString(_unref(pageSortDesc) ? _unref(lang).movieText.album_sort_asc
                            : _unref(lang).movieText.album_sort_desc), 1),
            _createElementVNode("span", null, _toDisplayString(_unref(lang).movieText.album_list_doc_down), 1),
            _createElementVNode("span", null, _toDisplayString(_unref(lang).movieText.album_list_audio_down), 1),
            _createElementVNode("span", null, _toDisplayString(_unref(lang).movieText.album_list_video_down), 1),
            _createElementVNode("span", null, _toDisplayString(_unref(lang).movieText.album_list_audio), 1),
            _createElementVNode("span", null, _toDisplayString(_unref(lang).movieText.album_list_video), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(pageData), (item, i) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_23, [
              (_unref(pageSortDesc))
                ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(_unref(data).pageIndex * _unref(data).pageSize + _unref(pageData).length - i), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_unref(data).pageIndex * _unref(data).pageSize + i + 1), 1)),
              _createElementVNode("a", {
                class: "link name",
                onClick: ($event: any) => (onPlay(item))
              }, _toDisplayString(item.title), 9, _hoisted_26),
              _createElementVNode("a", {
                class: _normalizeClass(["link icon i-a-1weishipin1", { disabled: !item.mp4 }]),
                onClick: ($event: any) => (onPlayVideo(item))
              }, null, 10, _hoisted_27),
              _createElementVNode("a", {
                class: _normalizeClass(["link icon i-a-4zanmeishige", { disabled: !item.mp3 }]),
                onClick: ($event: any) => (onPlayAudio(item))
              }, null, 10, _hoisted_28),
              _createElementVNode("a", {
                class: _normalizeClass(["link icon i-shipinxiazai", { disabled: !item.down_mp4 }]),
                onClick: ($event: any) => (onDownload(item, 3))
              }, null, 10, _hoisted_29),
              _createElementVNode("a", {
                class: _normalizeClass(["link icon i-yinpinxiazai", { disabled: !item.down_mp3 }]),
                onClick: ($event: any) => (onDownload(item, 4))
              }, null, 10, _hoisted_30),
              _createElementVNode("a", {
                class: _normalizeClass(["link icon i-wenjianxiazai", { disabled: !item.doc }]),
                onClick: ($event: any) => (onDownload(item, 5))
              }, null, 10, _hoisted_31)
            ]))
          }), 256))
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("section", null, [
          _createElementVNode("div", _hoisted_33, _toDisplayString(_unref(lang).movieText.album_recommend), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).detail?.recommend_list, (item) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              class: "tj link line",
              to: _unref(links).album(item.movid)
            }, {
              default: _withCtx(() => [
                _createVNode(Poster, {
                  url: item.thumb,
                  theme: "album"
                }, null, 8, ["url"]),
                _createElementVNode("div", _hoisted_34, _toDisplayString(item.title), 1),
                _createElementVNode("div", _hoisted_35, _toDisplayString(item.speaker), 1),
                _hoisted_36
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 256))
        ]),
        _createElementVNode("section", null, [
          _createElementVNode("div", _hoisted_37, _toDisplayString(_unref(lang).movieText.album_hot), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).detail?.hot_list, (item, i) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              class: "hot link line",
              to: _unref(links).album(item.movid)
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_38, _toDisplayString(i + 1), 1),
                _createElementVNode("div", _hoisted_39, _toDisplayString(item.title), 1),
                _createElementVNode("div", _hoisted_40, _toDisplayString(item.speaker), 1)
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 256))
        ]),
        _createElementVNode("section", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, _toDisplayString(_unref(lang).movieText.album_software), 1),
          _createElementVNode("div", _hoisted_43, [
            _hoisted_44,
            _createElementVNode("div", null, _toDisplayString(_unref(lang).movieText.album_software_intro), 1),
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("a", _hoisted_46, _toDisplayString(_unref(lang).movieText.album_software_download), 1)
            ])
          ])
        ])
      ])
    ]),
    (_unref(data).detail && _unref(state).moreVisible)
      ? (_openBlock(), _createBlock(MoreText, {
          key: 1,
          content: _unref(data).detail.content,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (_unref(state).moreVisible = false))
        }, null, 8, ["content"]))
      : _createCommentVNode("", true)
  ]))
}
}

})